document.addEventListener('DOMContentLoaded', function () {
  var flavorsWrap = document.getElementById('bb-flavors');
  var TOTAL_REQUIRED = flavorsWrap ? parseInt(flavorsWrap.dataset.totalRequired, 10) || 3 : 3;

  /* ---------- Thumbnail gallery ---------- */
  var mainImg = document.getElementById('bb-main-img');
  document.querySelectorAll('.bb-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.bb-thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      mainImg.src = thumb.dataset.full;
    });
  });

  /* ---------- Quantity steppers ---------- */
  var flavorEls = Array.prototype.slice.call(document.querySelectorAll('.bb-flavor'));

  function getTotal() {
    return flavorEls.reduce(function (sum, el) {
      return sum + parseInt(el.querySelector('.bb-step-qty').textContent, 10);
    }, 0);
  }

  function refreshButtons() {
    var total = getTotal();
    flavorEls.forEach(function (el) {
      var qtyEl = el.querySelector('.bb-step-qty');
      var qty = parseInt(qtyEl.textContent, 10);
      el.querySelector('.bb-step-plus').disabled = total >= TOTAL_REQUIRED;
      el.querySelector('.bb-step-minus').disabled = qty <= 0;
    });
  }

  flavorEls.forEach(function (el) {
    var qtyEl = el.querySelector('.bb-step-qty');
    el.querySelector('.bb-step-plus').addEventListener('click', function () {
      if (getTotal() >= TOTAL_REQUIRED) return;
      qtyEl.textContent = parseInt(qtyEl.textContent, 10) + 1;
      refreshButtons();
    });
    el.querySelector('.bb-step-minus').addEventListener('click', function () {
      var qty = parseInt(qtyEl.textContent, 10);
      if (qty <= 0) return;
      qtyEl.textContent = qty - 1;
      refreshButtons();
    });
  });

  refreshButtons();

  /* ---------- Add to cart / Buy now ---------- */
  var pageEl = document.querySelector('.bb-page');
  var MAIN_VARIANT_ID = pageEl ? parseInt(pageEl.dataset.mainVariantId, 10) : NaN;
  var errorBox = document.getElementById('bb-error');
  var addBtn = document.getElementById('bb-add-to-cart');
  var buyBtn = document.getElementById('bb-buy-now');

  function showError(msg) {
    if (errorBox) {
      errorBox.textContent = msg;
      errorBox.hidden = false;
    } else {
      alert(msg);
    }
  }

  function buildProperties() {
    var props = {};
    flavorEls.forEach(function (el) {
      var qty = parseInt(el.querySelector('.bb-step-qty').textContent, 10);
      if (qty > 0) {
        props[el.dataset.flavorName] = String(qty);
      }
    });
    return props;
  }

  function setLoading(isLoading) {
    [addBtn, buyBtn].forEach(function (btn) {
      if (!btn) return;
      btn.disabled = isLoading;
    });
  }

  function submitBoxToCart(event, redirectTo) {
    if (event) { event.preventDefault(); event.stopPropagation(); }
    if (errorBox) errorBox.hidden = true;

    if (getTotal() !== TOTAL_REQUIRED) {
      document.querySelector('.bb-build-note').style.display = 'none';
      showError('Please pick exactly ' + TOTAL_REQUIRED + ' bombs to build your box.');
      return;
    }

    if (isNaN(MAIN_VARIANT_ID) || MAIN_VARIANT_ID <= 0) {
      showError('This product is unavailable right now. Please refresh and try again.');
      return;
    }

    var payload = {
      id: MAIN_VARIANT_ID,
      quantity: 1,
      properties: buildProperties()
    };

    console.log('Box builder: adding to cart', payload); // TEMP DEBUG - remove once confirmed working

    setLoading(true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          console.log('Box builder test: /cart/add.js response', res.status, data); // TEMP DEBUG
          if (!res.ok) {
            throw new Error(data.description || data.message || 'Could not add to cart');
          }
          return data;
        });
      })
      .then(function () {
        window.location.href = redirectTo;
      })
      .catch(function (err) {
        console.error('Box builder add-to-cart failed:', err);
        showError(err.message);
        setLoading(false);
      });
  }

  if (addBtn) addBtn.addEventListener('click', function (e) { submitBoxToCart(e, '/cart'); });
  if (buyBtn) buyBtn.addEventListener('click', function (e) { submitBoxToCart(e, '/checkout'); });

  /* ---------- Copy promo code ---------- */
  // var copyBtn = document.getElementById('bb-copy-code');
  // if (copyBtn) {
  //   copyBtn.addEventListener('click', function () {
  //     var code = document.getElementById('bb-promo-code').textContent.trim();
  //     navigator.clipboard.writeText(code).then(function () {
  //       copyBtn.textContent = '✓';
  //       setTimeout(function () { copyBtn.textContent = '⧉'; }, 1500);
  //     });
  //   });
  // }
  const copyBtn = document.getElementById("bb-copy-code");

  if (!copyBtn) return;

  copyBtn.addEventListener("click", function () {

    const code = document
      .getElementById("bb-promo-code")
      .textContent.replace("Use Code:", "")
      .trim();

    navigator.clipboard.writeText(code);

    document.getElementById("copy-icon").style.display = "none";
    document.getElementById("tick-icon").style.display = "block";

    setTimeout(function () {
      document.getElementById("copy-icon").style.display = "block";
      document.getElementById("tick-icon").style.display = "none";
    }, 1500);

  });

});
